<template>
  <div class="table-wrapper" v-if="!!irregular || !!cladding">
    <table 
      class="table has-smallest-font mt-3"
      :class="{ 'is-fullwidth': isFullwidth }">
      <thead>
        <tr class="has-text-centered">
          <th
            v-for="(header, i) in headers"
            :key="i">
            {{ header.label }}
            <span 
              v-if="header.label == 'Area' && hasFootnotes"
              class="has-text-weight-normal">
              [1]
            </span>
          </th>
        </tr>
      </thead>

      <tbody>
        <tr>
          <td 
            class="category has-text-weight-bold" 
            :rowspan="!!irregular && !!cladding ? 3 : 2">
            Material
          </td>
          <template v-if="cladding">
            <td class="description has-text-weight-bold">
              <div v-if="materialSubcategories.length == 0">
                Stone Facing
              </div>
              <div v-else>
                <span 
                  v-for="(facing, i) in materialSubcategories" 
                  :key="facing">
                  <span v-if="i+1 == materialSubcategories.length && i != 0">&</span>
                  {{ facing }}
                  <span v-if="i+1 != materialSubcategories.length && 
                    i+1 != materialSubcategories.length - 1">,</span>
                </span>
              </div>
            </td>
            <td class="area has-text-weight-bold has-text-right">
              {{ cladding.measure | commasep(0) }}
            </td>
            <td class="unit has-text-weight-bold">
              Sq. Ft
            </td>
          </template>
        </tr>

        <tr v-if="cladding">
          <td class="description">
            <div class="has-text-weight-bold">
              Backing System
            </div>
            <div class="help">
              A cross section of the installation method is included.
            </div>
          </td>
          <td class="area has-text-weight-bold has-text-right">
            {{ cladding.measure | commasep(0) }}
          </td>
          <td class="unit has-text-weight-bold">
            Sq. Ft
          </td>
        </tr>

        <tr v-if="irregular">
          <td class="description">
            <div class="has-text-weight-bold">
              Fabricated Cladding
            </div>
          </td>
          <td class="area has-text-weight-bold has-text-right">
            {{ irregular.measure | commasep(0) }}
          </td>
          <td class="unit has-text-weight-bold">
            L. Ft
          </td>
        </tr>

        <tr>
          <td class="category has-text-weight-bold" rowspan="3">
            Service
          </td>
          <td class="description">
            <div class="has-text-weight-bold">
              Shop Drawings
            </div>
            <div class="help">
              Panel Layout & Engineering
            </div>
          </td>
          <td class="area has-text-weight-bold">
          </td>
          <td class="unit has-text-weight-bold">
            Set
          </td>
        </tr>

        <tr>
          <td class="description">
            <div class="has-text-weight-bold">
              Packaging and Delivery
            </div>
          </td>
          <td class="area has-text-weight-bold has-text-right">
            {{ runs }}
          </td>
          <td class="unit has-text-weight-bold">
            Runs
          </td>
        </tr>

        <tr>
          <td class="description">
            <div class="has-text-weight-bold">
              Installation
            </div>
          </td>
          <td class="area has-text-weight-bold has-text-right">
            Included
          </td>
          <td class="unit has-text-weight-bold">
            Crew
          </td>
        </tr>

      </tbody>

      <tfoot class="has-text-weight-bold">

        <tr>
          <td class="category" :rowspan="3">
            Pricing (CAD$)
          </td>
          <template v-if="cladding">
            <td class="description has-text-right">
              Regular Cladding
            </td>
            <td class="area">
              {{ cladding.price | currency(0) }}
            </td>
            <td class="unit"></td>
          </template>
        </tr>

        <tr v-if="irregular">
          <td class="description has-text-right">
            Fabricated Cladding
          </td>
          <td class="area">
            {{ irregular.price | currency(0) }}
          </td>
          <td class="unit"></td>
        </tr>

        <!-- <tr>
          <td class="description has-text-right">
            Package Discount 
          </td>
          <td class="area">
            {{ projectPrice - projectValue | currency(0) }}
          </td>
          <td class="unit"></td>
        </tr> -->

        <tr>
          <td class="description has-text-right">
            Total cost 
            <span class="has-text-weight-normal"> (Excl. HST)</span>
          </td>
          <td class="area">
            {{ projectPrice | currency }}
          </td>
          <td class="unit"></td>
        </tr>

        <!-- <tr>
          <td class="description has-text-right">
            HST 
          </td>
          <td class="area">
            {{ price * 0.13 | currency }}
          </td>
          <td class="unit"></td>
        </tr>

        <tr>
          <td class="description has-text-right">
            Total cost including HST 
          </td>
          <td class="area">
            {{ price * 1.13 | currency }}
          </td>
          <td class="unit"></td>
        </tr> -->

      </tfoot>

    </table>

    <div v-if="hasFootnotes" class="help">
      <div>
        [1] Area is including material waste.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    estimation: {
      type: Object
    },
    isFullwidth: {
      type: Boolean,
      default: false
    },
    hasFootnotes: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      headers: [
        { label: 'Item' },
        { label: 'Description' },
        { label: 'Area' },
        { label: 'Unit' }
      ]
    }
  },
  computed: {
    cladding({ estimation }) {
      return estimation.estimation_summary.summary.filter(
        d => d.pricing_summary.replaceAll(
            '_', ' '
        ).includes('cladding')
      )[0];
    },
    irregular({ estimation }) {
      return estimation.estimation_summary.irregular_price_by_material.filter(
        d => d.product_brand == 'Cladify'
      ).reduce((a,b) => {
        a['measure'] = a['measure'] + +b['sum_linear_ft'];
        a['what_should_be_paid'] = a['what_should_be_paid'] + +b['total_cost'];
        a['price'] = a['price'] + +b['adjusted_total_cost'];
        return a
      }, {
        measure: 0, 
        what_should_be_paid: 0, 
        price: 0
      });
    },
    projectValue({ cladding, irregular }) {
      if (!!cladding && !!irregular) {
        return +cladding.what_should_be_paid + +irregular.what_should_be_paid
      } else if (!irregular) {
        return cladding.what_should_be_paid
      } else {
        return irregular.what_should_be_paid
      }
    },
    projectPrice({ cladding, irregular }) {
      if (!!cladding && !!irregular) {
        return +cladding.price + +irregular.price
      } else if (!irregular) {
        return cladding.price
      } else {
        return irregular.price
      }
    },
    runs({ value, estimation }) {
      if (estimation.no_of_runs > 0) {
        return estimation.no_of_runs
      } else if (value) {
        return value
      } else {
        return 'included'
      }
    },
    materialSubcategories({ estimation }) {
      let res = estimation.items.map(d => d.materials).flat(1)
        .filter(d => d.product_master.product_brand == 'Cladify' &&
          d.product_master.product_category_id == 13 &&
          !!d.product_master.product_subcategory)
        .map(d => d.product_master.product_subcategory.subcategory);
      
      return [...new Set(res)];
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/table.scss';
@import '@/styles/detailed-pricing.scss';
</style>